import type { SupportTicketStatus } from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";
import Asterisk02Icon from "@redotech/redo-icons/asterisk-02_filled.svg";
import ClockSnoozeIcon from "@redotech/redo-icons/clock-snooze_filled.svg";
import StatusIcon from "@redotech/redo-icons/status.svg";
import { memo } from "react";
import {
  RedoBadge,
  type RedoBadgeSize,
} from "../arbiter-components/badge/redo-badge";
import FolderCheckIcon from "../icon-old/folder-check.svg";

/** Human-readable labels for support ticket statuses. */
export const SupportTicketStatusReadable: Record<SupportTicketStatus, string> =
  {
    OPEN: "Open",
    CLOSED: "Closed",
    SNOOZED: "Snoozed",
    IN_PROGRESS: "In Progress",
    HIDDEN: "Hidden",
    ARCHIVED: "Archived",
    DELETED: "Deleted",
    DRAFT: "Draft",
  };

const statusConfig: Record<
  SupportTicketStatus,
  {
    color: "success" | "gray" | "warning" | "blue" | "error";
    Icon: typeof Asterisk02Icon;
  }
> = {
  OPEN: { color: "success", Icon: Asterisk02Icon },
  CLOSED: { color: "gray", Icon: FolderCheckIcon },
  SNOOZED: { color: "warning", Icon: ClockSnoozeIcon },
  IN_PROGRESS: { color: "blue", Icon: StatusIcon },
  HIDDEN: { color: "gray", Icon: FolderCheckIcon },
  ARCHIVED: { color: "gray", Icon: FolderCheckIcon },
  DELETED: { color: "gray", Icon: FolderCheckIcon },
  DRAFT: { color: "error", Icon: FolderCheckIcon },
};

/** Support-v2 status badge. For legacy v1 conversations use RedoSupportStatusBadge. */
export const SupportTicketStatusBadge = memo(function SupportTicketStatusBadge({
  status,
  size = "sm",
}: {
  status: SupportTicketStatus;
  size?: RedoBadgeSize;
}) {
  const { color, Icon } = statusConfig[status];
  return (
    <RedoBadge
      color={color}
      segmentLeading={{ type: "icon", Icon }}
      size={size}
      text={SupportTicketStatusReadable[status]}
    />
  );
});
